<div class="tooltip-custom" *ngIf="showTooltip">
  <ng-content></ng-content>
</div>
